import { api } from '$utils/apiRequester'

export const UPLOAD_COVER_REQUEST = 'UPLOAD_COVER_REQUEST'
export const UPLOAD_COVER_SUCCESS = 'UPLOAD_COVER_SUCCESS'
export const UPLOAD_COVER_FAILURE = 'UPLOAD_COVER_FAILURE'

export const UPLOAD_AVATAR_REQUEST = 'UPLOAD_AVATAR_REQUEST'
export const UPLOAD_AVATAR_SUCCESS = 'UPLOAD_AVATAR_SUCCESS'
export const UPLOAD_AVATAR_FAILURE = 'UPLOAD_AVATAR_FAILURE'

export const UPLOAD_USER_REQUEST = 'UPLOAD_USER_REQUEST'
export const UPLOAD_USER_SUCCESS = 'UPLOAD_USER_SUCCESS'
export const UPLOAD_USER_FAILURE = 'UPLOAD_USER_FAILURE'

export const updateCover = (id, file) => {
  const formData = new FormData()
  formData.append('image', file)

  return {
    types: [UPLOAD_COVER_REQUEST, UPLOAD_COVER_SUCCESS, UPLOAD_COVER_FAILURE],
    promise: () =>
      api('ulule').patch(
        `/users/${id}/cover`,
        {
          body: formData
        },
        { type: 'formData', withAccessToken: true }
      )
  }
}

export const updateAvatar = (id, file) => {
  const formData = new FormData()
  formData.append('image', file)

  return {
    types: [UPLOAD_AVATAR_REQUEST, UPLOAD_AVATAR_SUCCESS, UPLOAD_AVATAR_FAILURE],
    promise: () =>
      api('ulule').patch(
        `/users/${id}/avatar`,
        {
          body: formData
        },
        { type: 'formData', withAccessToken: true }
      )
  }
}

export const updateUser = (id, params) => {
  return {
    types: [UPLOAD_USER_REQUEST, UPLOAD_USER_SUCCESS, UPLOAD_USER_FAILURE],
    promise: () =>
      api('ulule').patch(
        `/users/${id}`,
        {
          body: {
            ...params
          }
        },
        { withAccessToken: true }
      )
  }
}
